module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_20.f2e77fa9.jpg";